import type { GraphNode } from "@/types/knowledgeGraph"

/**
 * One place for the graph's visual vocabulary.
 *
 * The canvas and the legend have to agree about what a colour means, and a legend
 * that has drifted from the canvas is worse than none at all, so both read this.
 * The kinds mirror KnowledgeGraph::Schema::CONCEPT_KINDS.
 */
export const CONCEPT_KIND_COLORS: Record<string, string> = {
  commodity: "#38bdf8",
  macro_indicator: "#a78bfa",
  company: "#34d399",
  region: "#fbbf24",
  sector: "#f472b6",
  thesis: "#f87171",
  event: "#fb923c",
  instrument: "#22d3ee",
  person: "#c084fc",
  topic: "#94a3b8",
}

export const DEFAULT_CONCEPT_KIND = "topic"
export const DOCUMENT_COLOR = "#475569"
export const TAG_COLOR = "#64748b"

/** Edge types a traversal may follow, mirroring Schema::DEFAULT_TRAVERSAL_EDGE_LABELS. */
export const TRAVERSABLE_EDGE_TYPES = [
  "INFLUENCES",
  "CORRELATES_WITH",
  "SUPPLIES",
  "CONSUMES",
  "SUBSTITUTES_FOR",
  "HEDGES",
  "DERIVATIVE_OF",
  "LOCATED_IN",
  "OPERATES_IN",
] as const

export function nodeColor(node: GraphNode): string {
  if (node.label === "Document") return DOCUMENT_COLOR
  if (node.label === "Tag") return TAG_COLOR
  return CONCEPT_KIND_COLORS[node.kind ?? DEFAULT_CONCEPT_KIND] ?? CONCEPT_KIND_COLORS[DEFAULT_CONCEPT_KIND]
}

/** Human-readable form of a kind or edge type: MACRO_INDICATOR -> "macro indicator". */
export function humanizeToken(token: string): string {
  return token.toLowerCase().replace(/_/g, " ")
}
